import { useCallback } from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { ICheckAvailability } from '../types';
import { isAvailable } from '../utils';

/**
 * Utility hook for determining restaurant availability
 *
 * @returns {ICheckAvailability}
 * * Function that determines availability based on the result of the
 * * GetRestaurant query and the ENABLE_ORDERING LD flag
 * * If the query throws an errors, or the flag is off, then we default to `true`
 * * otherwise we return the `restaurant.available` boolean
 */
export const useGetStoreAvailabilityFn = (): ICheckAvailability => {
  const enableOrdering = useFlag(LaunchDarklyFlag.ENABLE_ORDERING);

  return useCallback(
    (rbiRestaurant: any) => {
      return enableOrdering && isAvailable(rbiRestaurant);
    },
    [enableOrdering]
  );
};
